<template>
  <div>
    <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap' }">
      <el-col :sm="12" :style="{ marginBottom: $mq === 'sm' ? '1rem' : null }">
        <ClientProfileDisplay
          :avatar="data && data.avatar"
          :name="fullName"
          :tel="data && data.tel"
        ></ClientProfileDisplay>
      </el-col>
      <el-col v-if="!readonly" :sm="12">
        <el-button icon="el-icon-edit" @click="select">
          {{ selectButtonText }}
        </el-button>
        <el-button icon="el-icon-plus" @click="add">เพิ่มลูกค้าใหม่</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ClientProfileDisplay from './ClientProfileDisplay'

export default {
  components: { ClientProfileDisplay },

  props: {
    data: {
      type: Object,
      default: null
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    fullName() {
      if (!this.data) return null

      const { firstName, lastName } = this.data
      return `${firstName} ${lastName}`.trim()
    },

    selectButtonText() {
      if (this.data) return 'เปลี่ยนลูกค้า'
      return 'ระบุลูกค้า'
    }
  },

  methods: {
    select() {
      this.$emit('select')
    },

    add() {
      this.$emit('add')
    }
  }
}
</script>

<style lang="scss" module>
.input {
  font-size: 1.25rem;

  :global(.el-input__inner) {
    font-weight: bold;
  }
}

.infoLabel {
  color: #5a5a5a;
  display: inline-block;
  margin-right: 0.5rem;
}

.infoText {
  color: #354052;
  display: inline-block;
  font-weight: bold;
}
</style>
